// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__3Jn49","subheader":"ReorderModal_subheader__guTjk","listWrap":"ReorderModal_listWrap__2cAld"};